import { reactive } from 'vue';
import config from '@/config'; // eslint-disable-line import/extensions
import { fetchRenderServers } from '@/services/renderServers';

const RENDER_SERVERS_TTL = 30 * 1000;

export const { renderServers } = config;

export const renderServersNames = Object.fromEntries(
  Object.entries(renderServers ?? {}).map(([key, value]) => [value, key]),
);

const staticRenderServersOptions = Object.entries(renderServersNames)
  .map(([value, label]) => ({ value, label }));

export const renderServersOptions = reactive([...staticRenderServersOptions]);

let lastLoadedAt = 0;
let pendingRequest = null;

const setDynamicRenderServersOptions = (dynamicOptions) => {
  const dynamicValues = new Set(dynamicOptions.map(({ value }) => value));

  renderServersOptions.splice(
    0,
    renderServersOptions.length,
    // Живой список приоритетнее статики: если сервер приехал из controlpanel,
    // одноимённый пресет из конфига дублировать не нужно.
    ...staticRenderServersOptions.filter(({ value }) => !dynamicValues.has(value)),
    ...dynamicOptions,
  );
};

/**
 * Подтягивает актуальные сервера рендера из controlpanel в renderServersOptions.
 *
 * Массив реактивный и общий для всех потребителей, поэтому вызывать можно
 * без ожидания результата. Если controlpanel недоступен — в списке остаются
 * только статические пресеты из конфига.
 */
export const ensureRenderServersLoaded = () => {
  if (pendingRequest) return pendingRequest;
  if (Date.now() - lastLoadedAt < RENDER_SERVERS_TTL) return Promise.resolve();

  pendingRequest = fetchRenderServers()
    .then((servers) => setDynamicRenderServersOptions(
      servers.map(({ name, label }) => ({ value: name, label })),
    ))
    .catch(() => setDynamicRenderServersOptions([]))
    .finally(() => {
      lastLoadedAt = Date.now();
      pendingRequest = null;
    });

  return pendingRequest;
};
